import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import type { IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'app-pricesheet-header',
  standalone: true,
  template: `
    <div class="custom-header">
      <i class="fa-light fa-book-open-reader header-icon"></i>
      <i (click)="onFilterClick($event)" class="far fa-magnifying-glass filter-icon"></i>
    </div>
  `,
  styles: [`
    .custom-header {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    .header-icon {
      font-size: 1.3rem;
      color: inherit;
    }

    .filter-icon {
      position: absolute;
      right: 10px;
      cursor: pointer;
    }
  `],
})
export class PricesheetHeaderComponent implements IHeaderAngularComp {
  params!: IHeaderParams;

  agInit(params: IHeaderParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  onFilterClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.params.showFilter(event.currentTarget as HTMLElement)
  }

}
